import React, { useState } from 'react';

interface NumberInputProps {
  id: string;
  name: string;
  value: number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  min?: number;
  max?: number;
  step?: number;
  label: string;
  description: string;
}

const NumberInput: React.FC<NumberInputProps> = ({
  id,
  name,
  value,
  onChange,
  min = 0,
  max,
  step = 1,
  label,
  description,
}) => {
  // The change handlers raise anything below the minimum (an empty field included) to it. Applied on each
  // keystroke, that puts the minimum back under the cursor: typing 120 into an emptied field gave 40120. So a
  // value below the minimum is kept as typed, and the handlers get it when the field is left.
  const [belowMinimum, setBelowMinimum] = useState<string | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const typed = parseFloat(e.target.value);
    if (isNaN(typed) || typed < min) {
      setBelowMinimum(e.target.value);
      return;
    }
    setBelowMinimum(null);
    onChange(e);
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    if (belowMinimum === null) return;
    setBelowMinimum(null);
    onChange(e as unknown as React.ChangeEvent<HTMLInputElement>);
  };

  return (
    <div className="form-group">
      <label htmlFor={id}>{label}</label>
      <div className="number-input-wrapper">
        <input
          id={id}
          type="number"
          name={name}
          value={belowMinimum ?? value}
          onChange={handleChange}
          onBlur={handleBlur}
          min={min}
          max={max}
          step={step}
        />
        <span className="field-description">{description}</span>
      </div>
    </div>
  );
};

export default NumberInput;
